/**
 * 関連書籍スライド
 */
$('.product-entry__books--list').slick({
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 6,
	slidesToScroll: 1,
	responsive: [
		{
			breakpoint: 901,
			settings: {
				slidesToShow: 4,
			},
		},{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
			},
		}
	]
});